import React, { Fragment } from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import { Row, Col } from 'reactstrap'

import { StyledFontAwesome } from '~/components/StyledComponents'

const Features = styled.section`
  text-align: center;
  border: 1px solid #333;
  padding: 1em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: column;
  height: calc(100% - 10px);

  p {
    font-size: 14px;
  }
`

const SectionTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 200;
  margin: 0.6rem 0 1rem 0;
`

const FeaturesList = ({ features }) => (
  <Row>
    {features.map(({ icon, title, text }) => (
      <Col sm="12" md="6" lg="4">
        <Features>
          <StyledFontAwesome background="transparent" name={icon} />
          {title && <SectionTitle>{title}</SectionTitle>}
          <p>{text}</p>
        </Features>
      </Col>
    ))}
  </Row>
)

export default FeaturesList



// WEBPACK FOOTER //
// ./src/components/pages/FeaturesList.js